export default __webpack_public_path__ + "static/media/auguest.png.webp";